// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"63a18a32","282":"8cf83392","471":"a9ef2090","778":"1ee73472","941":"1071e437","973":"df87df4e"}[chunkId] + ".chunk.js";
};